import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Headline, Hero } from '@xingternal/typography';

import { useBreakpoints, useLoginStates } from '@/hooks';

const StyledHeadline = styled(Headline)`
  margin-bottom: 0;
`;

const StyledHero = styled(Hero)`
  margin-bottom: 0;
`;

type Props = {
  company: string;
};

export const ApplyFormHeading: React.VFC<Props> = ({ company }) => {
  const { isMobile } = useBreakpoints();
  const { isLoggedIn } = useLoginStates();
  const copyKey = isLoggedIn ? 'JOBS_POSTING_EASY_APPLY_FORM_HEADER' : 'JOBS_POSTING_APPLY_FORM_LO_HEADING';

  return isMobile ? (
    <StyledHeadline size="xxlarge" forwardedAs="h1" data-cy="instant-apply-heading">
      <FormattedMessage id={copyKey} values={{ company }} />
    </StyledHeadline>
  ) : (
    <StyledHero size="small" forwardedAs="h1" data-cy="instant-apply-heading">
      <FormattedMessage id={copyKey} values={{ company }} />
    </StyledHero>
  );
};
